module.exports = __webpack_public_path__ + "static/ogp-483c5fd66ce2ebd9408b9f2a97a731d5.jpg";